window.addEventListener('DOMContentLoaded', () => {
  setInterval(() => {
    let original_total_price = 0;
    let money = 0;
    const items = document.querySelectorAll('.cd-product-item-content');

    items.forEach((item) => {
      const originalPriceEl = item.querySelector('.cd-original-price');
      const moneyEl = item.querySelector('.money');

      const itemMoney = moneyEl ? parseFloat(moneyEl.textContent.replace(/[^\d-]/g, '')) || 0 : 0;
      const itemOriginalPrice = originalPriceEl
        ? parseFloat(originalPriceEl.textContent.replace(/[^\d-]/g, '')) || 0
        : 0;

      if (itemOriginalPrice > 0) {
        original_total_price += itemOriginalPrice;
      } else {
        original_total_price += itemMoney;
      }

      money += itemMoney;

      console.log("discountdiscountdiscount", itemOriginalPrice, itemMoney);
    });

    let discount = original_total_price - money;

    document.querySelectorAll('.opus-price-ct-container').forEach(el => el.remove());
    const isPriceDiscount = discount > 0;
    document.querySelectorAll('.opus-btn-checkout').forEach(btn => {
      btn.insertAdjacentHTML(
        "beforebegin",
        `<div class="opus-price-ct-container" style="width: 100%; font-size: 16px; font-weight: bold; margin: auto;">
        
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
  <span style="flex-shrink: 0;">Articles</span>
  <span style="text-decoration: line-through; color: #b7b7b7;">
    ${window.OpusConvertMoney(original_total_price.toFixed(2))}
  </span>
</div>

          ${isPriceDiscount ? `
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
              <span style="flex-shrink: 0;color: #e96050;">Réduction</span>
              <span style="color: #e96050;">-${window.OpusConvertMoney(original_total_price.toFixed(2)- money.toFixed(2))}</span>
            </div>
          ` : ''}

<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
  <span style="flex-shrink: 0;">Livraison</span>
  <span>
    <span style="text-decoration: line-through; color: #b7b7b7;">
      ${window.OpusConvertMoney(500)}
    </span>
    <span style="color: #e96050; font-weight: bold; margin-left: 5px;">OFFERTE</span>
  </span>
</div>
          
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="flex-shrink: 0;">Total</span>
            <span>${window.OpusConvertMoney(money.toFixed(2))}</span>
          </div>
        </div>`
      );
    });
  }, 1000); 
});
